export const STATUS_ARRAY_WITH_NEW = ['Active', 'Inactive', 'Deleted', 'New'];
export const STATUS_ARRAY = ['Active', 'Inactive', 'Deleted'];
export const LEAGUES_ARRAY = ['MLB', 'NBA', 'NFL', 'Other'];

export const IMAGE_FOLDER_PATH = process.env.PUBLIC_URL + '/images/';
